
import React , {useEffect, useState}from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

// core components
import ReactTable from "components/ReactTable/ReactTable.js";



function VehicleTable(props) {
    const [data, setData] = useState([])

    useEffect(() => {
      console.log(props.categories)
      if(props.categories.categoryCode !== ""){
        let ndata =    props.vehicleList.filter(m => m.categoryCode === props.categories.categoryCode).map((aa,k) =>{
          return {
             id: k,
             vid: aa.vid ,
             categoryName: aa.category.en + " - " + aa.category.ar ,
             brandName : aa.bname.en + " - " + aa.bname.ar, 
             modelName : aa.mname.en + " - " + aa.mname.ar,
         
             blogo : aa.blogo,
             notes : aa.notes,
             ac : aa,
             actions: (
                 // we've added some custom button actions
                 <div className="actions-right">
                      <Button
                     onClick={() => {
                       let obj = props.vehicleList.find((o) => o.vid === aa.vid);
                         console.log(obj)
                      props.setVehicle(obj)
                        // console.log(obj)
                         props.setShowdetails(true)
                     }}
                     color="info"
                     size="sm"
                     className="btn-icon btn-link edit"
                   >
                    <i className="fa fa-info" aria-hidden="true"></i>
                   </Button>    {' '}
  
                   <Button
                     onClick={() => {
                     
                      let obj = props.vehicleList.find((o) => o.vid === aa.vid);
                         props.delvehicle(obj.vid)
                     }}
                     color="warning"
                     size="sm"
                     className="btn-icon btn-link remove"
                   >
                     <i className="fa fa-remove" />
                   </Button>
                 </div>
               ),
         }
        })
        setData(ndata)
      }else{
      
        let ndata = props.vehicleList.map((aa,k) =>{
          return {
             id: k,
             vid: aa.vid ,
             categoryName: aa.category.en + " - " + aa.category.ar ,
             brandName : aa.bname.en + " - " + aa.bname.ar, 
             modelName : aa.mname.en + " - " + aa.mname.ar,
         
             blogo : aa.blogo,
             notes : aa.notes,
             ac : aa,
             actions: (
                 // we've added some custom button actions
                 <div className="actions-right">
                      <Button
                     onClick={() => {
                       let obj = props.vehicleList.find((o) => o.vid === aa.vid);
                         props.setVehicle(obj)
                       //  console.log(obj)
                         props.setShowdetails(true)
                     }}
                     color="info"
                     size="sm"
                     className="btn-icon btn-link edit"
                   >
                    <i className="fa fa-info" aria-hidden="true"></i>
                   </Button>    {' '}
  
                   <Button
                     onClick={() => {
                       let obj = props.vehicleList.find((o) => o.vid === aa.vid);
                         props.delvehicle(obj.vid)
                     }}
                     color="warning"
                     size="sm"
                     className="btn-icon btn-link remove"
                   >
                     <i className="fa fa-remove" />
                   </Button>
                 </div>
               ),
         }
        })
        setData(ndata)
      }
      
        
    },[props.categories])

   

  return (
    <>
   
      <div className="content" >
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Models</CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data= {data}
                  columns={[
                    {
                        Header: "Img",
                        accessor: d =>  <center><img alt="..." width={"40px"} src={`${d.blogo}`} style={{ cursor : "pointer"}} /> </center>,
                      },
                      {
                        Header: "Code",
                        accessor: d =>  d.vid,
                      },
                    {
                      Header: "C.Name",
                      accessor: d =>  d.categoryName,
                    },
                   
                    {
                      Header: "Brand",
                      accessor: d => d.brandName,
                    },
                    {
                        Header: "Model",
                        accessor: d =>  d.modelName,
                      },
                     
                      {
                        Header: "Specs",
                        accessor: d => d.notes,
                      },
                  /**{     {
                        Header: "Year",
                        accessor: d =>  d.modelyear,
                      },}*/
                   
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  /*
                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                    */
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default VehicleTable;